<button
    pButton pRipple
    *ngIf="this.isButtonAuth"
    [disabled]="this.disabled"
    (click)="this.onButtonClick($event)"
    [label]="this.label"
    [class]="this.class"
    [style]="this.style"
    icon="{{this.icon}}">
</button>